import { Component, Prop, Vue } from 'vue-property-decorator';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';

@Component({
  components: {
    InlineLoader
  }
})
export default class PageLoader extends Vue {
  @Prop({ default: false }) visible: boolean;
  @Prop({ default: '' }) text: string;
}
